import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import PreRegistration from "./pages/PreRegistration";
import Search from "./pages/Search";
import Library from "./pages/Library";
import PhotoDetail from "./pages/PhotoDetail";
import CartPage from "./pages/CartPage";
import CuratedFrames from "./pages/CuratedFrames";
import { AuthProvider } from "./lib/auth";
import { CartProvider } from "./lib/cart";
import AuthModal from "./components/AuthModal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              {/* Public landing */}
              <Route path="/" element={<PreRegistration />} />

              {/* App is nested under /dashboard */}
              <Route path="/dashboard" element={<Home />} />
              <Route path="/dashboard/search" element={<Search />} />
              <Route path="/dashboard/library" element={<Library />} />
              <Route path="/dashboard/photo/:id" element={<PhotoDetail />} />
              <Route path="/dashboard/cart" element={<CartPage />} />
              <Route path="/dashboard/curated-frames" element={<CuratedFrames />} />

              {/* Legacy paths redirect to the landing page (app is now private) */}
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/search" element={<Navigate to="/" replace />} />
              <Route path="/library" element={<Navigate to="/" replace />} />
              <Route path="/photo/:id" element={<Navigate to="/" replace />} />
              <Route path="/cart" element={<Navigate to="/" replace />} />
              <Route path="/curated-frames" element={<Navigate to="/" replace />} />
            </Routes>
            <AuthModal />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
